import getScript from 'src/common/utils/injectScript';

const getAmazonPay = paymentMethods => paymentMethods.find(p => p.id === 'amazon_pay') || {};
export const getAmazonDetails = paymentMethods => getAmazonPay(paymentMethods).credentials;
export const isAmazonPaymentAvailable = paymentMethods => !!getAmazonPay(paymentMethods);
export const logoutAmazonUser = () => window.amazon.Login.logout();
export const setAmazonClientId = clientId => window.amazon.Login.setClientId(clientId);
export const onAmazonSetupWidget = (widgetUrl, callback) => getScript(widgetUrl, callback);
export const authorizeAmazonUser = ({ scope, popup, interactive }, callbackOrString) => {
  return window.amazon.Login.authorize({ scope, popup, interactive }, callbackOrString);
};

export const ensureAmazon = (timeout) => {
  const start = Date.now();
  return new Promise(waitForAmazon);
  function waitForAmazon(resolve, reject) {
    if (typeof window.OffAmazonPayments !== 'undefined' && typeof window.amazon !== 'undefined') {
      return resolve();
    } else if (timeout && Date.now() - start >= timeout) {
      return reject(new Error('Timeout'));
    }
    setTimeout(waitForAmazon.bind(this, resolve, reject), 50);
  }
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/Checkout/Amazon/helpers.js